module.exports = __webpack_public_path__ + "static/media/yash_pardeshi.54738b58.png";